module.exports = __webpack_public_path__ + "static/img/logo.83cd7bb.png";